import { Component, OnInit } from '@angular/core';
import { GtmService } from './core/services/gtm.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(private gtmService: GtmService) {}

  ngOnInit(): void {
    this.gtmService.initializeGTM();
  }
}
